// extracted by mini-css-extract-plugin
module.exports = {"socialLink":"SocialLinks_socialLink__gSdE7","noSvg":"SocialLinks_noSvg__akfso"};